export default [
  {
    path: "position",
    component: () => import("@/pages/recruit/position/list"),
    meta: { title: "项目招聘", cate: "项目管理" },
    children: [
      {
        path: "create",
        component: () => import("@/pages/recruit/position/CreateEdit"),
        meta: { title: "岗位发布" },
        hidden: true,
      },
      {
        path: "signup",
        component: () =>
          import(
            /* webpackChunkName: "position-list" */ "@/pages/position/Signup"
          ),
        meta: { title: "报名列表" },
        hidden: true,
      },
      {
        path: "registrationList",
        component: () =>
          import(
            /* webpackChunkName: "position-list" */ "@/pages/position/registrationList/index"
          ),
        meta: { title: "报名审核" },
        hidden: true,
      },
    ],
  },
  {
    path: "candidate",
    component: () => import("@/pages/recruit/candidate/list"),
    meta: { title: "人才库", cate: "招聘管理" },
    children: [
      {
        path: "resumeLibrary",
        component: () => import("@/pages/recruit/candidate/ResumeLibrary"),
        meta: { title: "人才列表" },
        hidden: true,
      },
    ],
  }
];
